<template>
  <CardComponent variant="tertiary">
    <template #header>
      {{ $tc('app.invoice', 2) }}
    </template>
    <TableComponent :fields="fields" :items="invoices" :busy="loading">
      <template #cell(total)="slotProps">
        {{ formatCurrency(slotProps.data) }}
      </template>
      <template #cell(status)="slotProps">
        <BadgeComponent v-if="slotProps.data == 'paid'" variant="success">{{ $tc('app.paid') }}</BadgeComponent>
        <BadgeComponent v-else-if="slotProps.data == 'pending'" variant="warning">{{ $tc('app.pending') }}</BadgeComponent>
      </template>
      <template #cell(actions)="slotProps">
        <a :href="slotProps.item.url">
          <span class="material-symbols-outlined">barcode_scanner</span>
        </a>
      </template>
    </TableComponent>
    <div class="row">
      <div class="col-12">
        <pagination :totalPages="pages" v-model="page" @change="fetch" />
      </div>
    </div>
  </CardComponent>
</template>

<script>
import moment from 'moment';
import TableComponent from '@/components/TableComponent.vue';
import Pagination from '@/components/PaginationComponent.vue';
import BadgeComponent from '@/components/ui/BadgeComponent.vue';
import CardComponent from '@/components/CardComponent.vue';

export default {
  name: 'InvoicesCard',
  components: {
    TableComponent,
    Pagination,
    BadgeComponent,
    CardComponent,
  },
  data() {
    return {
      loading: true,
      invoices: [],
      page: 1,
      pages: 1,
      fields: ['id', 'total', 'status', { key: 'created_at', formatter: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss') }, 'actions'],
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch(page = this.page) {
      this.page = page;
      this.loading = true;
      this.$store.dispatch('fetchInvoices', { page }).then((response) => {
        this.invoices = response.data.data;
        this.$emit('fetched', response.data.data);
        this.pages = response.data.last_page;
        this.loading = false;
      });
    },
    formatCurrency(currency) {
      return parseFloat(currency).toLocaleString('pt-BR', {
        style: 'currency',
        currency: this.$store.state.account.currency.length ? this.$store.state.account.currency : 'BRL',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card-header {
  margin-bottom: 15px;
}
.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}
.rebranding .card {
  height: calc(100% - 1.875rem);
}
.card {
  box-shadow: none;
}
.card-header {
  border-bottom: #6b23dc3d 4px solid !important;
  padding: 0px;
  padding-bottom: 5px;
}
.card-header .card-title {
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
}
.header_title {
  display: flex;
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
}
.card-header input {
  height: 30px !important;
}
.card-header button {
  height: 30px !important;
}
.m-left-10 {
  margin-left: 10px;
}
</style>
